<template>
  <div>
    <a-tabs>
      <a-tab-pane key="1" tab="成绩录入设置">
        <ScoreInputSetting />
      </a-tab-pane>
      <a-tab-pane key="2" tab="教师成绩录入">
        <TeacherScoreInput />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import ScoreInputSetting from '../score/ScoreInputSetting.vue'
import TeacherScoreInput from '../score/TeacherScoreInput.vue'

export default {
  components: {
    ScoreInputSetting,
    TeacherScoreInput
  }
}
</script>